import React from 'react';
export function Footer() {
  return <footer className="bg-ink px-3 py-4 text-center sm:px-6" data-id="element-64" data-mp="32wd2qgad7ltj">
      <p className="font-body text-[0.66rem] font-bold uppercase tracking-wide text-white/90" data-id="element-65" data-mp="3gfiuujlrgden">
        © 2026 CLINICAL LAB VISUAL ATLAS™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-1 max-w-2xl text-[0.64rem] leading-[1.35] text-white/55 sm:text-[0.72rem]" data-id="element-66" data-mp="36pfu1x8edv5r">
        CLINICAL LAB VISUAL ATLAS™ provides professional visual learning and
        reference resources for clinical laboratory science. It does not
        replace required professional training, validated laboratory
        procedures, clinical evaluation, diagnostic judgment, professional
        supervision or applicable laboratory guidelines.
      </p>
      <p className="mt-1 text-[0.64rem] text-white/70 sm:text-[0.72rem]" data-id="element-67" data-mp="3qblwzpgm4c1l">
        Terms &amp; Conditions • Privacy Policy • Contact
      </p>
      <p className="text-[0.64rem] text-white/70 sm:text-[0.72rem]" data-id="element-68" data-mp="2ey0ayd61uqka">
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="underline" data-id="element-69" data-mp="3l9k1v1qqp380">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}